<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('public.inpersonmeeting.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('modification.title') }} > </span>
            <span class="middle_loc">{{ $t('public.inpersonmeeting.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.new') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">

          <v-layout class="step_wrapper type2">
            <v-flex class="step_box step01">
              <h2>{{ $t('public.inpersonmeeting.fields.step_01') }}</h2>
              <p>{{ $t('public.inpersonmeeting.fields.search_application') }}</p>
            </v-flex>
            <v-flex class="step_box step02">
              <h2>{{ $t('public.inpersonmeeting.fields.step_02') }}</h2>
              <p>{{ $t('public.inpersonmeeting.fields.enter_details') }}</p>
            </v-flex>
            <v-flex class="step_box step03 active">
              <h2>{{ $t('public.inpersonmeeting.fields.step_03') }}</h2>
              <p>{{ $t('public.inpersonmeeting.fields.review_submit') }}</p>
            </v-flex>
          </v-layout>

          <v-layout column class="ma-0 pos-r center__wrapper mt-30">
            <v-flex class="inner_basic_wrap type2">
              <v-tabs
                v-model="activeTab"
                class="my_app_tabs_data type2"
                hide-slider
                grow
              >
                <v-tab href="#tab-1" class="mw-200">{{ $t('public.inpersonmeeting.fields.requests')  }}</v-tab>
                <v-tab href="#tab-2" class="mw-200" v-if="documentFileList.length > 0">{{ $t('public.translation.fields.attached_documents')  }}</v-tab>

                <v-tab-item value="tab-1">
                  <ApplicationInformation2
                    :receipt_no="receipt_no"
                    @empty="fnShow()"
                  />
                  <RequestInformation
                    :receipt_no="receipt_no"
                    v-if="showYn"
                  />
                  <h2 class="m_title mt-0">{{ $t('public.inpersonmeeting.fields.reason_for_meeting')  }}</h2>
                  <div>
                    <v-row class="ma-0 mt-10">
                      <v-col cols="12" class="pa-0 pt-0">
                        <v-textarea
                          outlined
                          class="pl-20 pr-20 login_text_filed"
                          v-model="notes"
                          readonly
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </div>

                  <div class="btn__fixed__wrapper">
                    <div class="btn__fixed__wrap">
                      <div class="btn_fixed__inner">

                        <v-btn
                          color="#acb0b3"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click="fnGoBefore()"
                        >{{ $t('common.button.before') }}</v-btn>

                        <v-btn
                          color="#007aff"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="!contentConfirm"
                          @click.stop="fnConfirmContent()"
                        ><v-icon small>mdi-check</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm') }}</v-btn>

                        <v-btn
                          color="#404040"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="contentConfirm"
                          @click.stop="fnCancelContent()"
                        ><v-icon small>mdi-close</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm_cancel') }}</v-btn>

                        <v-btn
                          color="#a01c2a"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          :disabled="!confirmYn"
                          @click="fnSubmit()"
                        ><v-icon small>mdi-send</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.submit') }}</v-btn>

                      </div>
                    </div>
                  </div>

                </v-tab-item>

                <v-tab-item :value="`tab-2`" v-if="documentFileList.length > 0">
                  <DocumentViewer
                    :items="documentFileList"
                  />
                  <v-layout class="btn_wraps mt-40">
                    <div class="btn__fixed__wrapper">
                      <div class="btn__fixed__wrap">
                        <div class="btn_fixed__inner">
                          <v-btn
                            color="#acb0b3"
                            dark
                            min-width="150"
                            min-height="50"
                            class="btn-normal br_none"
                            @click="fnGoBefore()"
                          >{{ $t('common.button.before') }}</v-btn>

                          <v-btn
                            color="#404040"
                            dark
                            min-width="150"
                            min-height="50"
                            v-if="docConfirm"
                            class="btn-normal br_none"
                            @click.stop="fnCancelDoc()"
                          ><v-icon x-small>mdi-close</v-icon><v-spacer class="hidden_lr2"></v-spacer>{{ $t('common.button.confirm_cancel') }}</v-btn>

                          <v-btn
                            color="#007aff"
                            dark
                            min-width="150"
                            min-height="50"
                            class="btn-normal br_none"
                            v-if="!docConfirm"
                            @click.stop="fnConfirmDoc()"
                          ><v-icon x-small>mdi-check</v-icon><v-spacer class="hidden_lr2"></v-spacer>{{ $t('common.button.confirm') }}</v-btn>

                          <v-btn
                            color="#a01c2a"
                            dark
                            min-width="150"
                            min-height="50"
                            class="btn-normal br_none"
                            :disabled="!confirmYn"
                            @click="fnSubmit()"
                          ><v-icon style="transform:rotate(-40deg) translateY(-3px);" x-small>mdi-send</v-icon><v-spacer class="hidden_lr2"></v-spacer>{{ $t('common.button.submit') }}</v-btn>
                        </div>
                      </div>
                    </div>
                  </v-layout>
                </v-tab-item>

              </v-tabs>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import DocumentViewer from '@/components/layout/DocumentViewer'
import ApplicationInformation2 from '@/components/layout/ApplicationInformation2'
import RequestInformation from '@/views/myrequest/RequestInformation'

export default {
  components :{
      ApplicationInformation2,
      RequestInformation,
      DocumentViewer
  },
  data () {
    return {
      activeTab : 'tab-1',
      receipt_no : this.$route.params.receipt_no,
      docConfirm : false,
      contentConfirm : false,
      notes : '',
      documentFileList: [],

      showYn: false
    }
  },
  computed : {
    confirmYn (){
      return (this.documentFileList.length == 0) ? this.contentConfirm : (this.docConfirm && this.contentConfirm)
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.fnGetContent()
    this.fnGetDocumentFileList()
  },
  methods: {
    fnGetContent(){
       requestApi({
        url: '/receivings/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.notes = res.data.notes
            this.contentConfirm = res.data.request_content_confirm == 'Y'
            this.docConfirm = res.data.ind_attached_confirm === 'Y'

            // draft 상태가 아니면 My Request 페이지로 이동
            if (res.data.service_type_code !== '6421'
              || res.data.receipt_status_type_code !== '4301'
              || res.data.receipt_step < 2) {
              this.$router.push('/myrequest/list')
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetContent()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetDocumentFileList() {
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/documents/files',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.documentFileList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetDocumentFileList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnConfirmContent(){
      let params = {
        request_content_confirm : 'Y'
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/request/confirm',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.confirm.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.contentConfirm = true
            this.activeTab = 'tab-2'
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnConfirmContent()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnCancelContent(){
      let params = {
        request_content_confirm : 'N'
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/request/confirm',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.cancel_confirm.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.contentConfirm = false

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnCancelContent()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnConfirmDoc(){
      let params = {
        ind_attached_confirm : 'Y'
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/attached/confirm',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.confirm.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.docConfirm = true

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnConfirmDoc()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnCancelDoc(){
      let params = {
        ind_attached_confirm : 'N'
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/attached/confirm',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.cancel_confirm.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.docConfirm = false
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnCancelDoc()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGoBefore(){
      this.$router.push({path : '/public/inpersonmeeting/step2/' + this.receipt_no })
    },
    fnSubmit(){
      requestApi({
        url: '/receivings/meeting/' + this.receipt_no + '/submit',
        method: 'PUT',
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.add.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.$router.push({path : '/myrequest/list'})
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSubmit()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnShow(){
      this.showYn = true
    }
  }
}
</script>